
import { defineComponent, onMounted, inject, ref } from "vue";
import { useRouter, useRoute } from "vue-router";

import * as ROUTES from "@/router/constants";
import navItems from "@/fixtures/navItems";
import animateFixedNav, {
  scrollToSection,
} from "@/components/FixedNav/animate";
import { NavItem, ActiveLinkContext } from "@/interfaces/nav";

export default defineComponent({
  name: "FixedNav",
  setup() {
    const $router = useRouter();
    const $route = useRoute();

    const { activeLink } = inject("active-link") as ActiveLinkContext;
    const isOpen = ref(false);

    const handleNavigation = (item: NavItem) => {
      const { url, type } = item;
      isOpen.value &&
        (() => {
          isOpen.value = false;
          document.body.style.overflowY = "auto";
        })();

      if (type === "internal") {
        if ($route.path !== "/") {
          $router.push({ path: "/", hash: url });
        } else {
          history.pushState({}, "", $route.path + url);
        }
        scrollToSection(url);
      }
    };

    const toggleMobileNav = () => {
      isOpen.value = !isOpen.value;
      document.body.style.overflowY = isOpen.value ? "hidden" : "auto";
    };

    onMounted(() => animateFixedNav());

    return {
      active: activeLink,
      isOpen,
      ROUTES,
      navItems,
      handleNavigation,
      toggleMobileNav,
    };
  },
});
